<template>
    <div v-show="isShowResult" class="betslip__result" :style="{ paddingTop: paddingTop + 'px' }">
        <div v-if="$store.state.isMobile" class="betslip__result-list">
            <template v-for="(item, index) in this.listNumber">
                <div
                    :class="[
                        'betslip__result-item',
                        { active: number === index || result.data.some((x) => x.number === item.number) },
                    ]"
                    :key="index"
                >
                    <img
                        class="betslip__result-item-image"
                        :src="addTimestampToURL(item.icon.unactive)"
                        :alt="item.number"
                    />
                </div>
            </template>
        </div>
        <div v-if="!$store.state.isMobile" class="betslip__result-list">
            <div class="betslip__result-item" v-for="(item, index) in renderListGame(1)" :key="index">
                <img
                    :class="[
                        'betslip__result-item-image',
                        { active: number === index || result.data.some((x) => x.number === item.number) },
                    ]"
                    :src="addTimestampToURL(item.icon.unactive)"
                    :alt="item.number"
                />
            </div>
        </div>
        <div class="betslip__result-box">
            <div class="betslip__result-box-item">
                <div v-if="$store.state.isMobile && isDemo" class="betslip__result-demo">
                    <span class="betslip__result-demo-text">
                        {{ getTranslatedText('Demo mode') }}
                    </span>
                </div>
                <div class="betslip__result-box-item-content">
                    <h3 class="betslip__result-title">
                        {{ getTranslatedText('Your Selection') }}
                    </h3>
                    <div class="betslip__result-selected">
                        <div class="betslip__result-selected-item" v-for="(item, index) in listSelected" :key="index">
                            <img
                                class="betslip__result-selected-image"
                                :src="addTimestampToURL(item.icon)"
                                :alt="item.number"
                            />
                            <span class="betslip__result-selected-number">
                                {{ item.number }}
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="result.isShow" class="betslip__result-result">
                    <span class="betslip__result-result-message" v-html="result.message"> </span>
                    <button class="betslip__result-result-button" @click="onTryAgain()">
                        {{ getTranslatedText('try again') }}
                    </button>
                </div>
                <div v-if="!$store.state.isMobile && isDemo" class="betslip__result-demo">
                    <span class="betslip__result-demo-text">
                        {{ getTranslatedText('Demo mode') }}
                    </span>
                </div>
            </div>
            <div class="betslip__result-box-item">
                <h2 class="betslip__result-title big">{{ getTranslatedText('Winning Number') }}...</h2>
                <div v-if="result.isShow" class="betslip__result-number">
                    <div class="betslip__result-number-item" v-for="(item, index) in result.data" :key="index">
                        <div class="betslip__result-number-item-box">
                            <img
                                class="betslip__result-number-item-image"
                                :src="addTimestampToURL(item.icon.unactive)"
                                :alt="item.number"
                            />
                            <span class="betslip__result-number-item-number">
                                {{ item.number }}
                            </span>
                        </div>
                        <div class="betslip__result-number-item-value">
                            <h3 class="betslip__result-number-title">{{ getTranslatedText(item.title) }}</h3>
                            <span class="betslip__result-number-description">
                                {{ getTranslatedText(item.description) }}
                            </span>
                            <div v-if="isDemo" class="betslip__result-demo">
                                <span class="betslip__result-demo-text">
                                    {{ getTranslatedText('Demo mode') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!result.isShow && isDemo" class="betslip__result-demo">
                    <span class="betslip__result-demo-text">
                        {{ getTranslatedText('Demo mode') }}
                    </span>
                </div>
            </div>
        </div>

        <div v-if="!$store.state.isMobile" class="betslip__result-list">
            <div class="betslip__result-item" v-for="(item, index) in renderListGame(2)" :key="index">
                <img
                    :class="[
                        'betslip__result-item-image',
                        {
                            active:
                                number === $store.state.itemRenderResult + index ||
                                result.data.some((x) => x.number === item.number),
                        },
                    ]"
                    :src="addTimestampToURL(item.icon.unactive)"
                    :alt="item.number"
                />
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import VersionCache from '@/mixins/version-cache/version-cache-mixins'
import gamesService from '@/services/games.service'
import EventBus from '@/utils/EventBus'

import { formatPrice, isArrayEmpty, isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins, themeMixins, VersionCache],
    props: {
        listNumber: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            activationInProgress: false,
            isShowResult: false,
            isDemo: false,
            listSelected: [],
            number: -1,
            paddingTop: 0,
            result: {
                isShow: false,
                message: '',
                data: [],
            },
        }
    },
    computed: {
        betslip() {
            return this.$store.state.betslip
        },
    },
    watch: {
        betslip: {
            handler(newValue) {
                if (!isArrayEmpty(newValue)) {
                    this.listSelected = [...newValue]
                }
            },
            deep: true,
        },
    },
    created() {
        this.number = Math.floor(Math.random() * this.listNumber.length - 1)
        EventBus.$on('on-hide-screen-betslip-result', () => this.onTryAgain())
    },
    mounted() {
        this.setPaddingTop()
        window.addEventListener('resize', this.setPaddingTop)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.setPaddingTop)
    },
    destroyed() {
        EventBus.$off('on-hide-screen-betslip-result', null)
    },
    methods: {
        resetData() {
            this.number = Math.floor(Math.random() * this.listNumber.length - 1)
            this.result.data = []
            this.result.message = ''
            this.result.isShow = false
        },

        openResult({ isDemo }) {
            this.isShowResult = true
            this.isDemo = isDemo
            this.resetData()
            this.activateItems()
            this.onSubmitBet()
            document.documentElement.classList.add('overflow-hidden')
            window.scrollTo({
                top: 0,
            })
        },

        renderListGame(type) {
            switch (type) {
                case 1:
                    return this.listNumber.slice(0, this.$store.state.itemRenderResult)
                case 2:
                    return this.listNumber.slice(this.$store.state.itemRenderResult, this.listNumber.length)
                default:
                    break
            }
        },

        activateItems() {
            if (this.activationInProgress) return
            this.activationInProgress = true

            const interval = setInterval(() => {
                if (this.listNumber.length && this.activationInProgress) {
                    this.number = Math.floor(Math.random() * this.listNumber.length - 1)
                } else {
                    clearInterval(interval)
                }
            }, 500)
        },

        onTryAgain() {
            if (!this.activationInProgress) {
                this.isShowResult = false
                this.resetData()
                document.documentElement.classList.remove('overflow-hidden')
                this.$store.dispatch('onClearbetslip')
            }
        },

        async onSubmitBet() {
            try {
                let bets = []
                this.$store.state.betslip.forEach((v) => {
                    const item = {
                        number: parseInt(v.number),
                        amount: v.price,
                    }
                    bets.push(item)
                })
                const resp = await gamesService.transactionBet(bets)

                if (resp.status === 'success' && resp.data?.status !== 'error') {
                    resp.data.result.forEach((number) => {
                        const index = this.listNumber.findIndex((item) => parseInt(item.number) === number)
                        if (index !== -1) {
                            this.result.data.push(this.listNumber[index])
                        }
                    })
                    this.number = -1

                    if (resp.data.win === 0) {
                        this.result.message = this.getTranslatedText(`You've lost!`)
                        return
                    }

                    const accountSetting = this.$store.state.accountSetting
                    const currency = accountSetting.currency.symbol

                    this.result.message = this.getTranslatedText('Total Bet Amount Won: <b>[currency] [price]</b>', {
                        price: this.formatMoney(resp.data.win),
                        currency,
                    })
                } else {
                    this.result.message = resp.data.message || ''
                }
            } catch (error) {
                let message = error?.message || ''
                if (!isArrayEmpty(error.errors)) {
                    error.errors.forEach((x) => {
                        message = `${!isStrEmpty(message) ? `${message} ${x.message}` : `${x.message}`}`
                    })
                }
                this.result.message = message || ''
            } finally {
                parent.postMessage({ command: 'refreshbalance' }, '*')

                this.$store.dispatch('onClearbetslip')
                this.$emit('on-close-betslip')
                this.activationInProgress = false
                this.result.isShow = true
            }
        },

        formatMoney(price) {
            return formatPrice(parseFloat(price))
        },

        setPaddingTop() {
            this.paddingTop = document.getElementById('nav-layout')?.clientHeight + 10 || 0
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/betslip/result.scss';
</style>
